import _ from "lodash";
import scrollIntoView from "scroll-into-view-if-needed";

/** scroll to an element smoothly */
export const scrollToElement = _.debounce((domNode: Element) => {
	// debounce scroll function so that if component is rendered multiple times quickly that
	// scroll will only happen after last render
	if (domNode) {
		scrollIntoView(domNode, {
			//https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
			// not all Safari support "smooth" option
			behavior: "auto",
			scrollMode: "if-needed",
		});
	}
}, 300);